/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  NFTVenuesHole,
  NFTVenuesHoleInterface,
} from "../../contracts/NFTVenuesHole";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "OperatorNotAllowed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "_baseURL",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_provenanceHash",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "whiteListId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mintValue",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "rootHash",
        type: "bytes32",
      },
    ],
    name: "addWhiteList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "whiteListId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "caps",
        type: "uint256[]",
      },
    ],
    name: "addWhiteListCapTracker",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "airdrop",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "receivers",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "batchAirdrop",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "flipMintState",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOpenWhiteList",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "whiteListId",
        type: "uint8",
      },
    ],
    name: "getWhiteList",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isMintOpen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "openMintValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "openWhiteListId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
    ],
    name: "setBaseURL",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newFeeReceiver",
        type: "address",
      },
    ],
    name: "setFeeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newMaxSupply",
        type: "uint256",
      },
    ],
    name: "setMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newMintValue",
        type: "uint256",
      },
    ],
    name: "setOpenMintValue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newProvenanceHash",
        type: "string",
      },
    ],
    name: "setProvenanceHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "whiteListId",
        type: "uint8",
      },
    ],
    name: "startWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "whiteListId",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "wallet",
        type: "address",
      },
    ],
    name: "whiteListCapTracker",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "proof",
        type: "bytes32[]",
      },
    ],
    name: "whiteListMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whiteLists",
    outputs: [
      {
        internalType: "uint256",
        name: "mintValue",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "rootHash",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "hasCap",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type NFTVenuesHoleConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NFTVenuesHoleConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NFTVenuesHole__factory extends ContractFactory {
  constructor(...args: NFTVenuesHoleConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      NFTVenuesHole & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): NFTVenuesHole__factory {
    return super.connect(runner) as NFTVenuesHole__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NFTVenuesHoleInterface {
    return new Interface(_abi) as NFTVenuesHoleInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): NFTVenuesHole {
    return new Contract(address, _abi, runner) as unknown as NFTVenuesHole;
  }
}
